import { useState } from 'react';
import { Icon } from '@iconify/react';
import ImgC1 from '../../assets/img/tecnologia/azure.png'
import ImgC2 from '../../assets/img/tecnologia/sqlserver.svg'
import ImgC3 from '../../assets/img/tecnologia/netcore.png'
import ImgC4 from '../../assets/img/tecnologia/react.png'
import ImgC5 from '../../assets/img/tecnologia/mysql.png'
import ImgC6 from '../../assets/img/tecnologia/vue.png'
import ImgC7 from '../../assets/img/tecnologia/aws.png'
import ImgC8 from '../../assets/img/tecnologia/postgresql.png'
import ImgC9 from '../../assets/img/tecnologia/nodejs.png'
import ImgC10 from '../../assets/img/tecnologia/Python-Logo.png'
import ImgC11 from '../../assets/img/tecnologia/swift_logo.png'
import ImgC12 from '../../assets/img/tecnologia/kotlin.png'
import ImgC13 from '../../assets/img/tecnologia/react-native.png'
import ImgC14 from '../../assets/img/tecnologia/next-js-logo.png'
import ImgC15 from '../../assets/img/tecnologia/logo_flutter.png'
import ImgC16 from '../../assets/img/tecnologia/mongodb.png'

const slides = [
  [ImgC1, ImgC2, ImgC3, ImgC4],
  [ImgC5, ImgC6, ImgC7, ImgC8],
  [ImgC9, ImgC10, ImgC11, ImgC12],
  [ImgC13, ImgC14, ImgC15, ImgC16],
];

export default function Carousel(){
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent(c => (c === 0 ? slides.length - 1 : c - 1));
  const next = () => setCurrent(c => (c === slides.length - 1 ? 0 : c + 1));

    return(
      <div className="relative max-w-5xl mx-auto">
        <div className="overflow-hidden">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {slides[current].map((img, i) => (
              <div key={i} className="flex items-center justify-center p-5 md:p-7 bg-[#ffffff0a] rounded-xl border border-black/10 hover:shadow-sm transition-shadow">
                <img src={img} className="w-full max-w-[160px] h-auto opacity-60 hover:opacity-100 transition-all" style={{filter: 'contrast(0)'}} alt="tech" />
              </div>
            ))}
          </div>
        </div>
        <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-10 h-10 rounded-full bg-[#f26724] border border-black/10 flex items-center justify-center text-gray-400 hover:text-[#f26724] hover:bg-orange-50 hover:border-[#f26724]/30 transition-all">
          <Icon icon="mdi:chevron-left" className="text-xl" />
        </button>
        <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-10 h-10 rounded-full bg-[#f26724] border border-black/10 flex items-center justify-center text-gray-400 hover:text-[#f26724] hover:bg-orange-50 hover:border-[#f26724]/30 transition-all">
          <Icon icon="mdi:chevron-right" className="text-xl" />
        </button>
        <div className="flex justify-center gap-2 mt-6">
          {slides.map((_, i) => (
            <button key={i} onClick={() => setCurrent(i)} className={`w-2 h-2 rounded-full transition-all ${i === current ? 'bg-[#f26724] w-6' : 'bg-gray-300 hover:bg-gray-400'}`} />
          ))}
        </div>
      </div>
    )
}
